<app-page-header [title]="title"></app-page-header>

<app-stacked-area-chart
  [dataSource]="data"
  [availableWidth]="windowWidth"
  [outerMargins]="chartMargins"
></app-stacked-area-chart>

<button (click)="addItem()">Add data point</button> |
<button (click)="popItem()">Remove data point</button>

<app-stacked-area-table [dataSource]="data"></app-stacked-area-table>
